import TxView from "./TxView";
export default TxView;
